import 'styled-components/macro';
import React from 'react';
import { useTheme, Typography } from '@harver/shared-ui';

import { ContentCard } from '../../components/ContentCard';
import { useContent } from '../../branding/content.context';

export function Cancelled() {
    const theme = useTheme();
    const { interviewCancellation: LANG } = useContent();

    document.title = LANG.thankYouPage.title;
    const template = LANG.alreadyCancelledInterview;

    return (
        <>
            <ContentCard>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        testId="cancellation.confirmation.title"
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                    >
                        {template.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.small,
                        }}
                        variant="body2"
                    >
                        {template.p1}
                    </Typography>

                    <Typography
                        css={{
                            textAlign: 'center',
                        }}
                        variant="body2"
                    >
                        {template.p2}
                    </Typography>
                </div>
            </ContentCard>
        </>
    );
}
